import QForm from './src/QForm';

QForm.install = Vue => {
  Vue.component(QForm.name, QForm);
};

export default QForm;
